import { useState, useEffect, useCallback } from 'react';
import endpoints from '../define/endpoints';

import axios from 'axios';

// TODO: this should be merged with useCoreCategories allowing some filters
export default function useFetchCategories(
  filters = { 'id[gt]': 5, _sort: 'popularity', _order: 'desc', _limit: 18 }
) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);

  const fetchCategories = useCallback(async () => {
    try {
      setIsLoading(true);
      const { data } = await axios.get(`${endpoints.core}/categories`, {
        params: {
          ...filters,
          locale: window.freedomeConfig.locale,
        },
      });
      setCategories(data);
    } catch (error) {
      setError(new Error(error));
      // console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [filters['id[gt]'], filters._sort, filters._order, filters._limit]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return { categories, isLoading, error, refetch: fetchCategories };
}
